import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M8.414 13.414 12 17a1.414 1.414 0 1 0 2-2l-3-3 3-3a1.414 1.414 0 1 0-2-2l-3.586 3.586a2 2 0 0 0 0 2.828"
    }
  )
);
var SvgChevronLeftOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ChevronLeftOutlined_default = SvgChevronLeftOutlined;

export { ChevronLeftOutlined_default as default };
